/**
 * elementui datepicker 日期格式化成指定的格式的指令
 * author：lilw
 */
export default {
  inserted: function(el, binding, vnode) {
    var { value: _obj } = binding;
    var { context: that, data } = vnode;
    var { expression: key } = data.model;
    var input = el.querySelector('.el-input__inner');
    var _date_format = "YYYY/MM/DD";
    if(_obj != null && _obj!=""){
      _date_format = _obj.toUpperCase();
    }

    var isDate = function(value) {
      var reg = /[1-9]\d{3}(((0[13578]|1[02])(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)(0[1-9]|[12][0-9]|30))|(02(0[1-9]|[1][0-9]|2[0-9])))/;
      if (!reg.test(value)) {
        return false;
      }
      var arr = value.split('/');
      var year = parseInt(arr[0]);
      var month = parseInt(arr[1]);
      var day = parseInt(arr[2]);
      if (month != 2 || day < 29) {
        return true; // 不必校验闰年，肯定是合法时间了
      }
      // 能被400整除，或者能被4整除但不能被100整除的都是闰年，其余的年份均为平年
      if (!(year % 400 == 0 || (year % 4 == 0 && year % 100 != 0))) {
        // 平年的2月只有28号
        if (month == 2 && day > 28) {
          return false;
        }
      }
      return true;
    }


    input.onblur =  function() {
      var value = input.value
      if(Number(value.length) == 8){
        var boo = isDate(value);
        console.log(boo);
        if(!boo){
          return ;
        }
        var date = this.$dayjs(value).format(_date_format);
        var _keys = key.split('.');
        if(_keys!= null && _keys.length >1){
          const [key1, key2, key3, key4] = _keys
          if (key4) {
            that[key1][key2][key3][key4] = date;
          } else if (key3) {
            that[key1][key2][key3] = date;
          } else {
            that[key1][key2] = date;
          }
        } else {
          that[key]= date;
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/modules/date-format.js